<div class="job-header-row">
  <button *ngIf="showBack" class="back-btn" type="button" aria-label="Back" (click)="onBack()">
    <i class="material-icons">keyboard_arrow_left</i>
  </button>

  <div class="job-details-header" [class.purple-band]="purpleBand">
    <div class="title">{{ title }}</div>

    <div class="chips" >
      <div class="chip-item">
        <img class="icon" src="assets/icons/job-planning/workflow.svg" alt="Workflow" />
        <div class="chip-body two-line">
          <span class="chip-label">Workflow</span>
          <span class="chip-value">{{ getWorkflowName(workflow) }}</span>
        </div>
      </div>
      <div class="chip-item" *ngIf="customer">
        <img *ngIf="customerLogo" class="icon" [src]="customerLogo" alt="Customer Logo" />
        <img *ngIf="!customerLogo" class="icon" src="assets/icons/job-planning/org-logo-job-header.svg" alt="Customer" />
        <div class="chip-body two-line">
          <span class="chip-label">Customer</span>
          <span
            class="chip-value chip-value--truncate"
            [matTooltip]="customer.orgName"
            matTooltipPosition="above"
            [matTooltipDisabled]="!customer.orgName"
          >{{ customer.orgName }}</span>
        </div>
      </div>
      <div class="chip-item">
        <img class="icon" src="assets/icons/job-planning/job-name.svg" alt="Job Name" />
        <div class="chip-body two-line">
          <span class="chip-label">Job Name</span>
          <span
            class="chip-value chip-value--truncate"
            [matTooltip]="jobName"
            matTooltipPosition="above"
            [matTooltipDisabled]="!jobName"
          >{{ jobName }}</span>
        </div>
      </div>
      <div class="chip-item">
        <img class="icon" src="assets/icons/job-planning/job-reference.svg" alt="Job Reference No." />
        <div class="chip-body two-line">
          <span class="chip-label">Job Reference No.</span>
          <span class="chip-value">{{ jobRef }}</span>
        </div>
        <span
          *ngIf="showJobActions"
          class="job-actions-tooltip-host"
          [matTooltip]="jobActionsDisabled ? jobActionsDisabledReason : null"
          [matTooltipDisabled]="!jobActionsDisabled || !jobActionsDisabledReason"
        >
          <button
            class="job-actions-btn"
            type="button"
            aria-label="Job actions"
            [disabled]="jobActionsDisabled"
            [matMenuTriggerFor]="jobActionsMenu"
          >
            <i class="material-icons">more_vert</i>
          </button>
        </span>
        <mat-menu #jobActionsMenu="matMenu" xPosition="before" class="job-actions-menu">
          <div class="job-actions-menu__title">Job Actions</div>
          <button mat-menu-item class="job-actions-menu__item" (click)="onTerminateJobClick()">
            <i class="material-icons job-actions-menu__icon">block</i>
            <span class="job-actions-menu__text">
              <span class="job-actions-menu__label">Terminate Job</span>
              <span class="job-actions-menu__hint">Stops the job and locks all its loads</span>
            </span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="collab">
      <div class="avatars">
        <ng-container *ngIf="collaboratorsWithPhotos$ | async as collaboratorsWithPhotos">
          <img *ngFor="let c of collaboratorsWithPhotos | slice:0:2; let i = index" class="avatar" [src]="c.avatarUrl" [alt]="c.name" [style.zIndex]="100 - i" />
        </ng-container>
        <ng-container *ngIf="extraCollaboratorCount$ | async as extraCount">
          <div class="avatar extra" *ngIf="extraCount > 0">+{{ extraCount }}</div>
        </ng-container>
      </div>
    </div>
    <img (click)="onAddCollaborator()" class="avatar add-user" src="assets/icons/add-user.svg" alt="Add user" />

  </div>

  <div class="logo-icon-container">
    <div *ngIf="checkLogoIcon(workflow)">
      <img class="optimize-icon" src="assets/icons/load-route-optimization.svg" alt="Load & Route Optimization" />
    </div>
    <div *ngIf="!checkLogoIcon(workflow)">
     <img class="optimize-icon" src="assets/icons/manual-route-planning.svg" alt="Manual route planning" />
    </div>
  </div>
</div>